import { GetterTree } from 'vuex';
import { State } from '@/manager/business/store/state';
import InternalBusiness from '@/manager/business/models/internal-business.model';


export interface Getters {
    getInternalBusinessList: InternalBusiness[];
}

export const getters: GetterTree<State, any> = {
    getInternalBusinessList: (state) => state.internalBusinessList,
    getInternalBusiness(state: State) {
        return (id: string) => {
            return state.internalBusinessList.find(
                (internalBusiness: any) => {
                    return internalBusiness.id === id;
                },
            );
        };
    },
    getProviderList: (state) => state.providerList,
    getProvider(state: State) {
        return (id: string) => {
            return state.providerList.find(
                (provider: any) => {
                    return provider.id === id;
                },
            );
        };
    },
};
